export const CONTACT_VERIFICATION_CODE_SOURCE =
    "WAGS-[0-9A-HJKMNP-TV-Z]{4}-[0-9A-HJKMNP-TV-Z]{4}";
export const LEGACY_CONTACT_TOKEN_SOURCE = "[A-HJ-NP-Z2-9]{6}";

export const CONTACT_VERIFICATION_CODE_PATTERN = new RegExp(
    `^${CONTACT_VERIFICATION_CODE_SOURCE}$`,
    "u",
);
export const LEGACY_CONTACT_TOKEN_PATTERN = new RegExp(
    `^${LEGACY_CONTACT_TOKEN_SOURCE}$`,
    "u",
);
export const CONTACT_SESSION_TOKEN_PATTERN = new RegExp(
    `^(?:${CONTACT_VERIFICATION_CODE_SOURCE}|${LEGACY_CONTACT_TOKEN_SOURCE})$`,
    "u",
);
